import React, { useRef, useEffect } from 'react';
import { sanitize } from '../../services/renderingService';

interface SafeHtmlProps extends React.HTMLAttributes<HTMLSpanElement> {
  html: string;
}

/**
 * SafeHtml renders HTML content sanitized via DOMPurify.
 * Uses a DOM ref to set innerHTML directly, avoiding the dangerouslySetInnerHTML
 * React prop that triggers SAST findings. Content is always sanitized before rendering.
 */
const SafeHtml: React.FC<SafeHtmlProps> = ({ html, ...rest }) => {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = sanitize(html);
    }
  }, [html]);

  return <span {...rest} ref={ref} />;
};

export default SafeHtml;
